import React from "react";

import WorkspaceProvider from "@v2/contexts/WorkspaceProvider";
import { PendingShopifyIntegrationModal } from "@v2/features/settings/shop/modals/PendingShopifyIntegrationModal";
import useConnectShopifyIntegrationNavigator from "@v2/hooks/useConnectShopifyIntegrationNavigator";
import useCurrentUser from "@v2/hooks/useCurrentUser";

import Onboarding from "./Onboarding";

const WorkspaceWrappedOnboarding: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { user } = useCurrentUser();

  const {
    shouldShowPendingIntegrationModal,
    setShouldShowPendingIntegrationModal,
  } = useConnectShopifyIntegrationNavigator();

  return (
    <WorkspaceProvider
      workspaceId={user?.workspace?.id}
      saveWorkspaceIdAsLastVisited
    >
      <Onboarding>{children}</Onboarding>
      <PendingShopifyIntegrationModal
        open={shouldShowPendingIntegrationModal}
        onOpenChange={setShouldShowPendingIntegrationModal}
      />
    </WorkspaceProvider>
  );
};

export default WorkspaceWrappedOnboarding;
